import { Component } from '@angular/core';
import {PromotionPopupDecisionType, PromotionPopupDto, PromotionPopupsClient} from '../../../api/portal-api.generated';
import {ActivatedRoute, Router} from '@angular/router';
import {ApplicationRouteSegments} from '../../enums/enums';

@Component({
  selector: 'app-sce-promotion',
  templateUrl: './sce-promotion.component.html',
  styleUrls: ['./sce-promotion.component.scss']
})
export class ScePromotionComponent {

  public profileId: string;

  promotionPopupDecisionType = PromotionPopupDecisionType;

  constructor(private promotionClient: PromotionPopupsClient,
              private route: ActivatedRoute,
              private router: Router) {
    this.profileId = this.route.snapshot.paramMap.get('profileId') as string;
  }

  async action(decision: PromotionPopupDecisionType) {
    const body: PromotionPopupDto = {
      profileId: this.profileId,
      decision,
    };

    try {
      await this.promotionClient.promotionPopups(body).toPromise();
    }
    catch(e) {
    }
    finally {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      decision === PromotionPopupDecisionType.Apply ? await this.navigateToSceMembership() : await this.close();
    }
  }

  async close() {
    await this.router.navigate([{ outlets: { popup: null } }]);
  }

  async navigateToSceMembership() {
    await this.close();

    await this.router.navigate([
      ApplicationRouteSegments.profile,
      this.profileId,
      ApplicationRouteSegments.sceMembership,
      ApplicationRouteSegments.sceMembershipDashboard
    ]);
  }

}
